interface QueryParams {
  [key: string]: string | number | boolean | null | undefined
}

export interface BackPathLocation {
  pathname: string
  search: string
}

export function queryParamsWithBackPath(location: BackPathLocation, params?: QueryParams): QueryParams {
  const p = { back_path: `${location.pathname}${location.search}` }
  return { ...p, ...params }
}

export function appGroupPath(groupId: number, params?: QueryParams): string {
  return appendQueryParams(`/app/groups/${groupId}`, params)
}

export function appSchedulePath(params?: QueryParams): string {
  return appendQueryParams("/app/schedule", params)
}

export function appLeagueRoundPath(roundId: number, params?: QueryParams): string {
  return appendQueryParams(`/app/league_rounds/${roundId}`, params)
}

export function appPlayerProfilePath(userId: string, params?: QueryParams): string {
  return appendQueryParams(`/app/u/${userId}`, params)
}

export function appFeedPostPath(postId: string, params?: QueryParams): string {
  return appendQueryParams(`/app/p/${postId}`, params)
}

export function appTeamRoundPath(teamRoundId: number, params?: QueryParams): string {
  return appendQueryParams(`/app/team_rounds/${teamRoundId}`, params)
}

export function appendQueryParams(path: string, params?: QueryParams): string {
  const url = new URL(path, window.location.origin)
  if (params) {
    for (const key in params) {
      const value = params[key]
      if (value === null || value === undefined) continue
      url.searchParams.append(key, String(value))
    }
  }
  return `${url.pathname}${url.search}`
}
